var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import onboardingService from "@irati/onboarding/services/onboarding";
import OnboardingSteps from "@irati/onboarding/enums/Step";
import { perksGoLinkedCardList } from "./queries";
import { perksGoRemoveCard } from "./mutations";
var PerksGoService = /** @class */ (function () {
    function PerksGoService() {
        var _this = this;
        this.getPerksGOCards = function (variables, options) {
            if (options === void 0) { options = {}; }
            return client.query(__assign(__assign({ fetchPolicy: "network-only" }, options), { query: perksGoLinkedCardList, variables: variables })).then(function (_a) {
                var _b;
                var data = _a.data;
                return (_b = data.linkedCards) === null || _b === void 0 ? void 0 : _b.results;
            });
        };
        this.unlinkCard = function (variables, options) {
            if (options === void 0) { options = {}; }
            return client.mutate(__assign(__assign({}, options), { mutation: perksGoRemoveCard, variables: variables }));
        };
        this.hasLinkedCard = function (user, options) {
            if (options === void 0) { options = {}; }
            var userId = user.uuid;
            return _this.getPerksGOCards({ userId: userId }, options).then(function (linkedCards) {
                return linkedCards.length > 0;
            });
        };
        this.shouldShowPerksGoBanner = function (user, options) {
            if (options === void 0) { options = {}; }
            var userId = user.uuid;
            return Promise.all([_this.hasLinkedCard(user, options), onboardingService.get(userId, options)]).then(function (_a) {
                var hasLinkedCard = _a[0], completedSteps = _a[1].completedSteps;
                var hasDismissedLinkCardBanner = completedSteps.includes(OnboardingSteps.HAS_DISMISSED_LINK_CARD_BANNER);
                if (hasLinkedCard && !hasDismissedLinkCardBanner) {
                    _this.hasDismissedLinkedCardBanner(user);
                }
                return !hasLinkedCard && !hasDismissedLinkCardBanner;
            });
        };
        this.hasDismissedLinkedCardBanner = function (user) {
            onboardingService.completeStep(user, OnboardingSteps.HAS_DISMISSED_LINK_CARD_BANNER);
        };
    }
    return PerksGoService;
}());
export default new PerksGoService();
